import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ReportHistoryMobilePage } from '@/pages/mobile/employee/ReportHistoryMobilePage';
import { ReportSubmitMobilePage } from '@/pages/mobile/employee/ReportSubmitMobilePage';

type ReportsTab = 'today' | 'history';

export function EmployeeReportsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = (searchParams.get('tab') as ReportsTab) || 'today';
  const viewOnly = searchParams.get('mode') === 'view';

  const activeTab: ReportsTab = tab === 'history' ? 'history' : 'today';

  const switchTab = (next: ReportsTab) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('tab', next);
    if (next !== 'today') {
      nextParams.delete('mode');
    }
    setSearchParams(nextParams, { replace: true });
  };

  const todayVariant = useMemo(() => {
    if (viewOnly) {
      return 'mobile-view' as const;
    }
    return 'mobile' as const;
  }, [viewOnly]);

  return (
    <div>
      <div className="mobile-segment-tabs">
        <button
          type="button"
          className={`mobile-segment-tabs__item${activeTab === 'today' ? ' mobile-segment-tabs__item--active' : ''}`}
          onClick={() => switchTab('today')}
        >
          今日日报
        </button>
        <button
          type="button"
          className={`mobile-segment-tabs__item${activeTab === 'history' ? ' mobile-segment-tabs__item--active' : ''}`}
          onClick={() => switchTab('history')}
        >
          历史日报
        </button>
      </div>

      {activeTab === 'today' ? (
        <ReportSubmitMobilePage variant={todayVariant} />
      ) : (
        <ReportHistoryMobilePage />
      )}
    </div>
  );
}
